import get from 'lodash/get';

export const isEnabled = (s, key) => {
  return get(s, `sectionData.${key}_isEnabled`, 'true') === 'true';
};
